



































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";
import {GetKey} from "@/utils/base";

@Component({
  components: {
    DsEditor,
  },
})
export default class Name extends Vue {
  @Prop()
  private ifEdit: any;
  @Prop()
  private detail: any;
  @Prop()
  private time: any;

  @Watch("detail", {immediate: true})
  private detailChange() {
    // 处理数据
    // if (this.detail != null && this.detail.length > 0) {
    //   let d: any = JSON.parse(JSON.stringify(this.detail[0]));
    //   this.data = d['data'];
    //   console.log(">>>>>>>>>>",this.data )
    //
    // }

  }

  private get patient() {
    return this.$store.state.patient;
  }

  private get bmiInfo() {
    return this.$store.state.bmiInfo;
  }

  private data: any = {};

  private get systemInfo() {
    return this.$store.state.systemInfo;
  }

  private keyVal(val: any) {
    return GetKey(val);
  }

  private get user() {
    return this.$store.state.user;
  }

  private editorChange(e: any) {
    const d = JSON.parse(JSON.stringify(this.detail));
    d.report["建议"].suggest = e;
    this.$emit("changeData", d);
  }

  private open(url: any) {
    window.open(url);
  }

  private mounted() {
  }
}
